import { formatISO, isFuture, isValid, parse, parseISO } from 'date-fns'
import { boolean, object, string } from 'yup'

const QUESTION_OPTIONS = ['A', 'B', 'C', 'D']

const AygoXJuicyCoutureCompetitionSchema = object().shape({
  first_name: string()
    .required('First name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'First name can only contain letters and basic punctuation',
    )
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must be at most 50 characters')
    .trim(),
  last_name: string()
    .required('Last name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'Last name can only contain letters and basic punctuation',
    )
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must be at most 50 characters')
    .trim(),
  email: string()
    .required('Email is required')
    .matches(
      /^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/,
      'Email must be a valid email address',
    )
    .max(255)
    .trim(),
  dob: string()
    .required('Please enter your date of birth')
    .transform((value) => {
      if (!value || !/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return value
      const parsed = parse(value, 'dd/MM/yyyy', new Date())
      return isValid(parsed) ? formatISO(parsed, { representation: 'date' }) : value
    })
    .test(
      'is-valid-date',
      'Please enter a valid date of birth',
      (value) => !value || isValid(parseISO(value)),
    )
    .test(
      'is-future',
      'Date of birth cannot be in the future',
      (value) => !value || !isFuture(parseISO(value)),
    ),
  postcode: string()
    .trim()
    .matches(
      /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/,
      'Postcode must be a valid UK postcode',
    )
    .required('Postcode is required'),
  question_1: string()
    .required('Please select an answer')
    .oneOf(QUESTION_OPTIONS, 'Please select an answer'),
  question_2: string()
    .required('Please select an answer')
    .oneOf(QUESTION_OPTIONS, 'Please select an answer'),
  question_3: string()
    .required('Please select an answer')
    .oneOf(QUESTION_OPTIONS, 'Please select an answer'),
  is_lexus: boolean(),
  response_code: string().required().uppercase().trim(),
  campaign_response_code: string().uppercase().trim(),
  campaign_code: string().uppercase().trim(),
  consent: object({
    user: boolean(),
  }),
})

export default AygoXJuicyCoutureCompetitionSchema
